import PlaceholderInstitutionLogo from './PlaceholderInstitutionLogo';
import { ContinueLinkingItem } from './Types';
import { Box } from '@mui/material';

interface ContinueLinkingLogoProps {
  institution: ContinueLinkingItem;
  size?: 'sm' | 'md' | 'lg';
}

function getRenderableInstitutionLogoSrc(logo?: string | null): string | undefined {
  if (!logo) {
    return undefined;
  }

  if (
    logo.startsWith('data:') ||
    logo.startsWith('http://') ||
    logo.startsWith('https://') ||
    logo.startsWith('blob:') ||
    logo.startsWith('/')
  ) {
    return logo;
  }

  return `data:image/png;base64,${logo}`;
}

const ContinueLinkingLogo: React.FC<ContinueLinkingLogoProps> = ({ institution, size = 'md' }) => {
  const logoSize = size === 'sm' ? 20 : size === 'lg' ? 35 : 25;
  const logoSrc = getRenderableInstitutionLogoSrc(institution.institutionLogo);

  if (logoSrc) {
    return (
      <Box
        alt={institution.institutionName}
        component='img'
        src={logoSrc}
        sx={{
          height: logoSize,
          objectFit: 'contain',
          width: logoSize,
        }}
      />
    );
  }

  return <PlaceholderInstitutionLogo size={size} />;
};

export default ContinueLinkingLogo;
